module.exports = __webpack_public_path__ + "img/Flag_of_Sweden.97ce2d67.svg";